"use strict";
// @ts-ignore
try {
    self['workbox:broadcast-update:5.1.4'] && _();
}
catch (e) { }
